import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { getDataReader, RPWDataReader } from "../../livedataFuncs";
import { store } from "../../redux/store";
import { DatePicker } from "../datePicker";

function setRegistrationDateFunc(DataReaderObj, RegistrationDateString) {
    if (RegistrationDateString > '' && RegistrationDateString !== null && RegistrationDateString !== undefined) {
        DataReaderObj.setTransferRegistrationDate(RegistrationDateString);
    }
}

function setInstrumentNumberFunc(DataReaderObj, InstrumentNumberString) {
    if (InstrumentNumberString !== null && InstrumentNumberString !== undefined) {
        DataReaderObj.setTransferInstrumentNumber(InstrumentNumberString);
    }
}

const Registrations = () => {
    let dataRoot = store?.getState()?.currentNavigation.livedataRootContainer.dataRoot;
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(dataRoot);


    const [InstrumentNumber, setInstrumentNumber] = useState<string>('');
    let transferInstrumentNumber = DataReaderObj.getTransferInstrumentNumber();
    if (transferInstrumentNumber === undefined || transferInstrumentNumber === null) {
        transferInstrumentNumber = '';
    }
    transferInstrumentNumber = transferInstrumentNumber.replace(/^"(.*)"$/, '$1');
    if (transferInstrumentNumber !== InstrumentNumber) {
        setInstrumentNumber(transferInstrumentNumber);
    }

    const [registrationDate, setRegistrationDate] = useState<string>('');
    let registrationStr = DataReaderObj.getRegistrationDate();
    if (registrationStr === undefined || registrationStr === null) {
        transferInstrumentNumber = '';
    }
    // registrationStr = registrationStr.replace(/^"(.*)"$/, '$1');
    if (registrationStr !== registrationDate) {
        setRegistrationDate(registrationStr);
    }

    useEffect(() => {
        let registrationStr = DataReaderObj.getRegistrationDate();
        if (registrationDate > '' && registrationDate !== null && registrationDate !== undefined && (registrationDate !== registrationStr)) {
            setRegistrationDateFunc(DataReaderObj, registrationDate);
        }
    }, [registrationDate])

    useEffect(() => {
        if (InstrumentNumber !== null && InstrumentNumber !== undefined) {
            setInstrumentNumberFunc(DataReaderObj, InstrumentNumber);
        }
    }, [InstrumentNumber])
    return (
        <>
            <Card.Header>
                <h2>Registrations</h2>
            </Card.Header>
            <Card.Body  >
                <table>
                    <tr>
                        <td>Description</td>
                        <td>Instrument Number</td>
                        <td>Registration Date</td>
                    </tr>
                    <br />
                    <tr>
                        <td style={{}}>Transfer</td>
                        <td>
                            {
                                InstrumentNumber !== null && InstrumentNumber !== undefined ?
                                    <input
                                        id='TransferInstrumentNumber'
                                        placeholder="Enter text..."
                                        defaultValue={transferInstrumentNumber}
                                        // onBlur={ele => {
                                        //     setInstrumentNumber(ele.target.value);
                                        //     setInstrumentNumberFunc(DataReaderObj, ele.target.value);
                                        // }}
                                        >
                                    </input>
                                    :
                                    null
                            }
                        </td>
                        <td>
                            <DatePicker
                                date={registrationDate}
                                setDate={setRegistrationDate}
                            />
                        </td>
                    </tr>
                </table>
            </Card.Body>
        </>
    )
}

export default Registrations;